import React from "react";
import { Target, Brain, Trophy } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Hack the Board",
    body: "Filter 338,947+ live ATS jobs by salary, stack, remote, visa across 18,000+ company boards. Hit apply where humans actually read.",
    icon: Target,
    bg: "bg-[#FFE600]",
    rotate: "-rotate-[2deg]",
  },
  {
    n: "02",
    title: "Prep with AI",
    body: "Generate an ATS-bulletproof resume in 90s. Score it against live roles. Role-play the interview until you can't fail.",
    icon: Brain,
    bg: "bg-[#0055FF]",
    fg: "text-white",
    rotate: "rotate-[2deg]",
  },
  {
    n: "03",
    title: "Get Hired (or Build)",
    body: "Land the offer — or follow a playbook and launch your own thing. Either way, you stop scrolling LinkedIn.",
    icon: Trophy,
    bg: "bg-[#00FF66]",
    rotate: "-rotate-[1deg]",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works"
      className="relative border-b-4 border-[#0a0a0a] bg-[#0a0a0a] text-[#FDFBF7] overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-[0.06] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="mb-14 md:mb-20 reveal">
          <div className="font-accent text-sm bg-[#FFE600] text-[#0a0a0a] inline-block px-3 py-1 mb-4">
            HOW IT WORKS
          </div>
          <h2 className="font-display text-5xl md:text-7xl">
            Three moves.
            <br />
            <span className="text-[#FFE600]">Zero excuses.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-10">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-${i + 1}`}
                className={`${s.bg} ${s.fg || "text-[#0a0a0a]"} ${s.rotate} border-4 border-[#0a0a0a] shadow-brutal p-7 md:p-8 relative hover-pop reveal`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="font-display text-7xl md:text-8xl leading-none">
                    {s.n}
                  </div>
                  <div className="w-12 h-12 border-4 border-[#0a0a0a] bg-[#0a0a0a] text-[#FFE600] flex items-center justify-center">
                    <Icon size={22} strokeWidth={2.5} />
                  </div>
                </div>
                <h3 className="font-display text-2xl md:text-3xl mb-3">
                  {s.title}
                </h3>
                <p className="font-mono-body text-sm md:text-base leading-relaxed">
                  {s.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
